/*
 * Views for the substitution group search bar
 */

define([
  "marionette",
  "modules/substitutions/substitutionSearch/template/substitutionSearchTemplate.html",
], function (Marionette, SubstitutionSearchTemplate) {
  var SubstitutionSearchView = {};

  SubstitutionSearchView.substitutionSearchView = Marionette.ItemView.extend({
    template: SubstitutionSearchTemplate,
    triggers: {
      "click #search": "click:search",
      "click #reset": "clear:search",
      "click #searchEntries": "change:filter:mode",
    },
    modelEvents: {
      change: "render",
    },
    getSearchValue: function () {
      return this.$el.find("#searchTerm").val();
    },
    setSearchValue: function (value) {
      this.$el.find("#searchTerm").val(value);
    },
  });

  return SubstitutionSearchView;
});
